// extracted by mini-css-extract-plugin
module.exports = {"content":"CardsWithIcon_content___CHeN","card":"CardsWithIcon_card__ltSRg","iconContainer":"CardsWithIcon_iconContainer__jseWb"};